import React from 'react';
import ThemedInput from '../../../../../../common/components/ThemedInput';

// eslint-disable-next-line no-unused-vars
const TextArea = ({ options, ...restProps }) => {
  return (
    <ThemedInput
      style={{ resize: 'none' }}
      multiline
      maxLength={500}
      counter={true}
      {...restProps}
    />
  );
};

export default TextArea;



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/QuestionGroup/InputTypes/TextArea.js